import { socketWithAdminToken, socketWithMerchantToken } from '@lib/api/v2';
import { getAllToken } from '@util/token';

/**
 * 소켓 연결 인증 토큰 발급 (LETMEUP-876)
 * POST /v2/backoffice/socket/auth-token — 인증된 지점/권한을 담은 소켓 전용 토큰(1h)을 받는다.
 * merchantToken 우선, 없으면 adminToken으로 시도. 둘 다 없거나 실패하면 null을 반환하고
 * 소켓은 무토큰(legacy)으로 연결한다 — 서버가 무토큰 연결을 허용하므로 기능이 깨지지 않는다.
 */
export const postSocketAuthToken = async (): Promise<string | null> => {
  const { merchantToken, adminToken } = getAllToken();
  const instance = merchantToken ? socketWithMerchantToken : adminToken ? socketWithAdminToken : null;
  if (!instance) return null;
  try {
    const res = await instance.post('/auth-token');
    return res?.data?.data?.socketToken ?? null;
  } catch (error) {
    return null;
  }
};
